import React, {FC} from 'react';

/**
 * 隐私政策韩语正文（与 zh.tsx / en.tsx 结构逐元素 1:1，类名复用 PrivacyPolicy__* BEM）
 * 2026-09-17 AI 번역, 법률 문구는 비즈니스 검토 대기
 */
const KoContent: FC = () => {
  return (
    <>
      <p className="v3-doc-meta">시행일: August 28, 2026</p>
      <p className="v3-doc-meta">최종 업데이트: August 28, 2026</p>
      <h3>개인정보 보호 안내문</h3>
      <p>Xiangji가 제공하는 제품과 서비스를 이용해 주셔서 감사합니다!</p>
      <p>
        Xiangji(이하 "Xiangji" 또는 "당사")는 이용자의 개인정보와 프라이버시 보호를 매우 중요하게 생각합니다. 본
        개인정보 처리방침(이하 "본 처리방침")은 이용자가 Xiangji의 웹사이트, 웹 애플리케이션, 클라이언트, 브라우저 확장
        프로그램, API 및 기타 관련 서비스를 등록, 로그인, 방문 또는 이용할 때 당사가 이용자의 개인정보를 수집, 이용,
        저장, 공유, 보호 및 처리하는 방식과 적용 법률에 따라 이용자가 가지는 권리를 설명합니다.
      </p>
      <p>
        Xiangji는 크로스보더 이커머스 및 기타 비즈니스 이용자를 위해 AI 시각 콘텐츠 처리 및 제작 서비스를 주로 제공하며,
        여기에는 이미지 번역, 이미지 편집, 이미지 생성, 상품 장면 이미지 생성, 상품 모델 이미지 생성, 상품 메인·서브
        이미지 생성, 상품 상세 이미지 세트 생성, 마케팅 소재 생성 등의 기타 관련 서비스가 포함되나 이에 국한되지
        않습니다.
      </p>
      <p>
        <strong>
          Xiangji의 서비스를 이용하기 전에 본 개인정보 처리방침을 주의 깊게 읽고 충분히 이해하셨는지 확인해 주시기
          바랍니다. 특히 이용자의 중대한 권리와 이익에 관한 굵게 표시된 내용에 유의해 주시기 바랍니다.
        </strong>
      </p>
      <p>
        본 개인정보 처리방침은 Xiangji 이용 약관, Xiangji 구독 구매 계약 및 기타 적용되는 서비스별 계약과 함께 Xiangji의
        서비스 이용 약관 체계 전체를 구성합니다.
      </p>
      <p>
        본 개인정보 처리방침의 어느 부분이라도 동의하지 않으시는 경우, Xiangji의 서비스 이용을 중지해 주시기 바랍니다.
      </p>
      <section>
        <h2>1. 수집하는 정보</h2>
        <p>
          이용자가 이용하는 Xiangji 기능과 당사와의 상호작용 방식에 따라, 당사는 다음과 같은 유형의 정보를 수집할 수
          있습니다.
        </p>
        <h3>계정 및 신원 정보</h3>
        <p>Xiangji의 서비스에 등록하거나 로그인 또는 이용할 때, 당사는 다음을 수집할 수 있습니다:</p>
        <ul>
          <li>이름 또는 닉네임;</li>
          <li>이메일 주소;</li>
          <li>휴대전화 번호;</li>
          <li>프로필 사진;</li>
          <li>제3자 계정 정보;</li>
          <li>계정 ID;</li>
          <li>회사명, 직책 및 이용자가 자발적으로 제공하는 기타 정보;</li>
          <li>계정 등록, 신원 확인 및 계정 관리에 사용되는 기타 정보.</li>
        </ul>
        <p>
          Google, Apple, WeChat 또는 기타 제3자 계정으로 로그인하는 경우, 당사는 제3자 플랫폼이 허용한 범위 내에서
          이용자의 공개 계정 정보 일부를 취득할 수 있습니다.
        </p>
        <p>
          <strong>당사는 이용자가 제3자 계정으로 로그인한다는 이유로 제3자 계정의 비밀번호를 취득하지 않습니다.</strong>
        </p>
        <h3>이용자가 업로드 및 제출하는 콘텐츠</h3>
        <p>
          Xiangji는 AI 시각 콘텐츠 제작 및 처리 서비스입니다. 따라서 이용자가 관련 기능을 능동적으로 이용할 때, 당사는
          이용자가 업로드, 제출 또는 입력하는 콘텐츠를 처리할 수 있으며, 여기에는 다음이 포함되나 이에 국한되지
          않습니다:
        </p>
        <ul>
          <li>상품 이미지;</li>
          <li>상품 상세 이미지;</li>
          <li>상품 메인·서브 이미지;</li>
          <li>이미지 속 텍스트;</li>
          <li>상품명, 설명, 사양 및 파라미터;</li>
          <li>프롬프트 및 기타 텍스트 지시;</li>
          <li>이미지 편집 지시;</li>
          <li>영상 및 오디오;</li>
          <li>PSD 및 기타 디자인 파일;</li>
          <li>AI 생성 결과물;</li>
          <li>이용자가 자발적으로 제출하는 기타 콘텐츠.</li>
        </ul>
        <p>
          <strong>
            상기 콘텐츠에는 영업 비밀, 상업 자료 또는 기타 상업적 가치를 지닌 정보가 포함될 수 있습니다. 업로드하기 전에
            해당 콘텐츠를 Xiangji에 제공하여 처리할 권리가 이용자에게 있는지 확인해 주시기 바랍니다.
          </strong>
        </p>
        <h3>거래 및 결제 정보</h3>
        <p>Xiangji 구독 또는 기타 유료 서비스를 구매할 때, 당사는 다음을 수집할 수 있습니다:</p>
        <ul>
          <li>주문 정보;</li>
          <li>이용자가 구매하는 플랜 및 서비스;</li>
          <li>거래 금액;</li>
          <li>거래 시간;</li>
          <li>결제 상태;</li>
          <li>청구서 및 관련 정보;</li>
          <li>거래와 관련된 계정 정보.</li>
        </ul>
        <p>
          <strong>
            은행 카드 번호, 신용카드 번호, 결제 비밀번호 등 민감한 결제 정보는 통상 제3자 결제 대행사가 직접 처리하도록
            합니다. 원칙적으로 Xiangji는 전체 은행 카드 번호나 결제 비밀번호를 직접 저장하지 않습니다.
          </strong>
        </p>
        <p>결제 정보의 구체적인 처리 방식은 해당 결제 대행사의 개인정보 처리방침에도 따릅니다.</p>
        <h3>기기 및 로그 정보</h3>
        <p>이용자가 Xiangji의 서비스를 방문하거나 이용할 때, 당사는 다음을 자동으로 수집할 수 있습니다:</p>
        <ul>
          <li>IP 주소;</li>
          <li>브라우저 유형 및 버전;</li>
          <li>운영 체제;</li>
          <li>기기 유형;</li>
          <li>기기 식별자;</li>
          <li>언어 설정;</li>
          <li>시간대;</li>
          <li>접속 시간;</li>
          <li>페이지 방문 기록;</li>
          <li>클릭, 조작 및 기능 사용 기록;</li>
          <li>API 호출 기록;</li>
          <li>오류 로그;</li>
          <li>네트워크 상태;</li>
          <li>기타 필요한 기술 로그 정보.</li>
        </ul>
        <p>이 정보는 주로 서비스의 정상 운영 유지, 장애 분석, 제품 경험 개선 및 플랫폼 보안 확보에 사용됩니다.</p>
        <h3>쿠키 및 유사 기술</h3>
        <p>당사는 쿠키, Local Storage, SDK 및 기타 유사 기술을 다음 목적으로 사용할 수 있습니다:</p>
        <ul>
          <li>로그인 상태 유지;</li>
          <li>이용자 설정 저장;</li>
          <li>이전 조작 기억;</li>
          <li>제품 사용 분석;</li>
          <li>계정 및 서비스 보안 보호;</li>
          <li>제품 기능 개선;</li>
          <li>서비스 사용량 측정.</li>
        </ul>
        <p>
          <strong>
            이용자는 브라우저 또는 기기 설정을 통해 쿠키를 관리하거나 삭제할 수 있으며, 일부 쿠키를 비활성화하면 특정
            기능이 정상적으로 작동하지 않을 수 있습니다.
          </strong>
        </p>
      </section>
      <section>
        <h2>2. 개인정보 이용 방식</h2>
        <p>
          당사는 합법적, 정당하고 필요한 목적 범위 내에서 이용자의 개인정보를 처리하며, 주요 시나리오는 다음과 같습니다:
        </p>
        <h3>서비스 제공 및 유지</h3>
        <p>여기에는 다음이 포함됩니다:</p>
        <ul>
          <li>계정 생성 및 관리;</li>
          <li>신원 확인;</li>
          <li>이미지 번역 서비스 제공;</li>
          <li>이미지 편집 및 처리 서비스 제공;</li>
          <li>AI 이미지 생성 서비스 제공;</li>
          <li>상품 상세 이미지 세트 및 메인/서브 이미지 생성 서비스 제공;</li>
          <li>영상 및 기타 시각 콘텐츠 처리 서비스 제공;</li>
          <li>작품 및 이력 저장;</li>
          <li>주문 및 구독 처리;</li>
          <li>고객 지원 제공.</li>
        </ul>
        <h3>AI 서비스 처리</h3>
        <p>
          AI 관련 기능을 이용할 때, 당사는 이용자가 제공한 이미지, 텍스트, 프롬프트, 상품 정보 및 기타 입력을 다음
          목적으로 사용할 수 있습니다:
        </p>
        <ul>
          <li>이용자의 요구 파악;</li>
          <li>적절한 AI 모델 호출;</li>
          <li>이미지 번역, 생성, 편집 또는 처리 완료;</li>
          <li>AI 출력 생성;</li>
          <li>생성 이력 저장;</li>
          <li>생성 결과 표시;</li>
          <li>관련 서비스 경험 개선.</li>
        </ul>
        <p>
          <strong>
            AI 관련 서비스를 제공하기 위해 특정 기능 구현에 필요한 데이터를 해당 AI 모델 제공사, 클라우드 제공사 또는
            기타 기술 서비스 제공사에 이전해야 할 수 있습니다. 자세한 내용은 본 개인정보 처리방침의 "정보 공유, 위탁
            처리 및 제3자 서비스" 절을 참조해 주시기 바랍니다.
          </strong>
        </p>
        <h3>서비스 개선 및 제품 분석</h3>
        <p>
          적용 법률 및 규정과 본 개인정보 처리방침의 조건에 따라, 당사는 관련 정보를 다음 목적으로 사용할 수 있습니다:
        </p>
        <ul>
          <li>제품 분석;</li>
          <li>서비스 품질 분석;</li>
          <li>문제 해결;</li>
          <li>성능 최적화;</li>
          <li>사용자 경험 개선;</li>
          <li>제품 기능 개발;</li>
          <li>보안 위험 분석.</li>
        </ul>
        <p>
          <strong>
            이용자의 별도 동의를 얻거나 적용 법률 및 규정이 허용하는 경우를 제외하고, 당사는 이용자의 개인정보를 수집
            목적과 관련 없는 용도로 사용하지 않습니다.
          </strong>
        </p>
        <h3>고객 서비스</h3>
        <p>
          이용자가 문의, 불만 또는 피드백으로 당사에 연락할 때, 당사는 이용자가 제공한 정보를 신원 확인, 문제 파악 및
          서비스 제공에 사용할 수 있습니다.
        </p>
        <h3>보안 및 리스크 관리</h3>
        <p>당사는 관련 정보를 다음 목적으로 사용할 수 있습니다:</p>
        <ul>
          <li>계정 도용 방지;</li>
          <li>사기 방지;</li>
          <li>비정상 로그인 탐지;</li>
          <li>악의적 호출 방지;</li>
          <li>트래픽 부정 증가 및 부정 차익 취득 방지;</li>
          <li>플랫폼 규칙 위반 탐지;</li>
          <li>플랫폼과 이용자의 보안 유지.</li>
        </ul>
        <h3>알림 및 마케팅</h3>
        <p>당사는 다음과 같은 중요한 서비스 관련 알림을 보낼 수 있습니다:</p>
        <ul>
          <li>계정 보안 알림;</li>
          <li>주문 및 결제 알림;</li>
          <li>구독 상태 알림;</li>
          <li>서비스 변경 알림;</li>
          <li>본 개인정보 처리방침 및 서비스 이용 약관 업데이트 알림.</li>
        </ul>
        <p>
          <strong>상기 알림은 서비스 제공에 필요한 중요한 알림으로, 이용자는 통상 수신을 거부할 수 없습니다.</strong>
        </p>
        <p>
          마케팅 메시지, 프로모션 이벤트 및 기타 상업 정보는 적용 법률 및 규정과 관련 동의 규칙에 따라 이용자에게
          발송됩니다. 법률에서 요구하는 경우, 당사는 수신 거부 또는 구독 취소에 상응하는 옵션을 제공합니다.
        </p>
      </section>
      <section>
        <h2>3. AI 서비스 및 이용자 업로드 콘텐츠에 대한 특별 규정</h2>
        <p>Xiangji는 AI 시각 콘텐츠 제작 서비스를 제공하므로, 본 절에서는 관련 데이터 처리에 대해 특별히 설명합니다.</p>
        <h3>이용자 업로드 콘텐츠</h3>
        <p>
          이용자가 이미지, 텍스트, 영상, PSD 파일 또는 기타 콘텐츠를 능동적으로 업로드하여 Xiangji에 처리를 요청하는
          경우, 당사는 관련 서비스 제공에 필요한 범위 내에서 해당 콘텐츠를 처리합니다.
        </p>
        <p>예를 들어:</p>
        <p>
          이용자가 상품 이미지를 업로드하고 "이미지 번역"을 선택하면, 당사는 이미지 속 시각 콘텐츠와 텍스트를 처리하여
          번역을 완료하고 새로운 이미지를 생성할 수 있습니다.
        </p>
        <p>
          이용자가 상품 정보를 입력하고 "메인 이미지 생성"을 선택하면, 당사는 관련 상품 정보와 이용자의 생성 지시를
          처리하여 AI 생성 작업을 완료할 수 있습니다.
        </p>
        <h3>AI 모델 서비스</h3>
        <p>
          <strong>
            일부 AI 기능을 제공하기 위해, 이용자의 입력은 Xiangji가 이용하는 제3자 AI 모델 또는 기술 서비스 제공사로
            이전되어야 할 수 있습니다.
          </strong>
        </p>
        <p>
          당사는 비즈니스 필요에 따라 상응하는 보안 역량과 서비스 조건을 갖춘 벤더를 선정하고, 적용 법률 및 규정과 계약
          약정에 따라 관련 데이터를 관리합니다.
        </p>
        <p>구체적인 제3자 서비스는 기술 솔루션과 제품 기능의 조정에 따라 변경될 수 있습니다.</p>
        <h3>학습 금지 원칙</h3>
        <p>
          <strong>
            이용자의 명시적 동의를 얻거나 적용 법률 및 규정이 허용하거나, 관련 서비스 페이지에 명확히 다르게 고지하는
            경우를 제외하고, Xiangji는 이용자가 업로드한 상업 자료, 상품 이미지, 프롬프트 또는 기타 이용자 콘텐츠를
            제3자 AI 모델 학습에 사용하지 않습니다.
          </strong>
        </p>
        <p>
          향후 당사가 해당 데이터를 모델 학습, 알고리즘 최적화 또는 기존 서비스 목적과 실질적으로 다른 기타 용도로
          사용할 계획인 경우, 적용 법률 및 규정에 따라 상응하는 고지 및 동의 의무를 이행합니다.
        </p>
        <h3>AI 생성 결과물</h3>
        <p>AI 생성 결과물에는 원본 입력과 다른 정보나 콘텐츠가 포함될 수 있습니다.</p>
        <p>
          당사는 이력, 다운로드, 재편집 등의 제품 기능을 제공하기 위해 이용자의 생성 작업과 결과물을 보관할 수 있습니다.
        </p>
        <p>
          <strong>이용자는 실제 상업 활용 시나리오에 따라 AI 생성 결과물을 직접 검토해 주시기 바랍니다.</strong>
        </p>
      </section>
      <section>
        <h2>4. 정보 공유 및 처리 위탁 방식</h2>
        <p>당사는 이용자의 개인정보를 판매하지 않습니다.</p>
        <p>다음의 경우, 당사는 필요한 정보를 제3자와 공유하거나 해당 제3자에게 처리를 위탁할 수 있습니다:</p>
        <h3>기술 서비스 제공사</h3>
        <p>Xiangji의 서비스를 제공하기 위해, 당사는 제3자가 제공하는 다음 서비스를 이용할 수 있습니다:</p>
        <ul>
          <li>클라우드 컴퓨팅 서비스;</li>
          <li>오브젝트 스토리지 서비스;</li>
          <li>AI 모델 서비스;</li>
          <li>기계 번역 서비스;</li>
          <li>OCR 서비스;</li>
          <li>이미지 처리 서비스;</li>
          <li>데이터 분석 서비스;</li>
          <li>고객 지원 서비스;</li>
          <li>이메일 및 SMS 서비스;</li>
          <li>결제 서비스;</li>
          <li>보안 서비스.</li>
        </ul>
        <p>
          <strong>
            당사는 특정 서비스 완료에 필요한 정보만을 해당 제공사에 제공하며, 적용 법률 및 규정과 쌍방 간 약정에 따라
            관련 정보를 처리하도록 요구합니다.
          </strong>
        </p>
        <h3>결제 대행사</h3>
        <p>유료 서비스를 구매할 때, 관련 거래는 제3자 결제 기관을 통해 완료될 수 있습니다.</p>
        <p>결제 기관은 자사의 개인정보 처리방침에 따라 결제 관련 정보를 독자적으로 처리할 수 있습니다.</p>
        <h3>기업 고객</h3>
        <p>
          이용자가 회사, 학교 또는 기타 조직이 제공한 계정으로 Xiangji의 서비스를 이용하는 경우, 계정 정보와 서비스 이용
          정보의 일부는 해당 조직이 관리할 수 있습니다.
        </p>
        <p>
          해당 조직이 이용자의 개인정보 처리자 또는 비즈니스 관리자 역할을 하는 경우, 데이터 처리 규칙에 대해서도 해당
          조직을 통해 확인해 주시기 바랍니다.
        </p>
        <h3>법률 및 규제 요구</h3>
        <p>
          다음의 경우, 당사는 법률 및 규정 또는 정부, 사법, 규제 기관의 적법한 요청에 따라 관련 정보를 공개할 수
          있습니다:
        </p>
        <ul>
          <li>법정 의무 이행;</li>
          <li>사법 조사 협조;</li>
          <li>행정 조사 협조;</li>
          <li>이용자 또는 공공의 안전 보호;</li>
          <li>Xiangji의 정당한 권리와 이익 보호;</li>
          <li>사기, 위법 또는 보안 사고 처리.</li>
        </ul>
        <h3>기업 운영 변경</h3>
        <p>
          Xiangji가 합병, 분할, 인수, 자산 이전, 재편 또는 기타 유사 거래를 진행하는 경우, 이용자의 개인정보는 관련 사업
          자산의 일부로 이전될 수 있습니다.
        </p>
        <p>
          <strong>
            해당 거래로 인해 개인정보 처리의 목적이나 방식에 중대한 변경이 발생하는 경우, 당사는 적용 법률 및 규정에
            따라 상응하는 고지 의무를 이행합니다.
          </strong>
        </p>
      </section>
      <section>
        <h2>5. 개인정보의 국외 이전</h2>
        <p>
          Xiangji는 전 세계 크로스보더 이커머스 이용자에게 서비스를 제공합니다. 일부 서버, AI 모델, 클라우드 서비스 또는
          기타 기술 서비스 제공사는 중국 외부에 위치할 수 있습니다.
        </p>
        <p>
          따라서,
          <strong>
            일정한 경우, 이용자에게 서비스를 제공하기 위해 이용자의 관련 개인정보 또는 이용자 콘텐츠를 다른 국가 또는
            지역으로 이전하여 처리해야 할 수 있습니다.
          </strong>
        </p>
        <p>예를 들어:</p>
        <ul>
          <li>해외 AI 모델을 사용하여 이미지 생성을 완료;</li>
          <li>해외 클라우드 서비스를 사용하여 데이터 저장 또는 처리;</li>
          <li>해외 결제 서비스를 사용하여 구독 구매를 완료;</li>
          <li>해외 고객 지원, 이메일 또는 데이터 분석 서비스를 이용.</li>
        </ul>
        <p>
          <strong>
            관련 데이터 처리에 개인정보의 국외 이전이 포함되는 경우, 당사는 적용 법률 및 규정에 따른 상응하는
            컴플라이언스 의무를 이행하고 합리적인 보안 보호 조치를 취합니다.
          </strong>
        </p>
        <p>
          지역별 이용자에 대해, 당사는 적용 법률 및 규정에 따라 서로 다른 데이터 국외 처리 메커니즘을 채택할 수
          있습니다.
        </p>
      </section>
      <section>
        <h2>6. 개인정보 보호 방식</h2>
        <p>
          당사는 개인정보 보안을 중요하게 생각하며, 이용자의 정보를 보호하기 위해 합리적인 기술적, 관리적 조치를
          취합니다. 여기에는 다음이 포함되나 이에 국한되지 않습니다:
        </p>
        <ul>
          <li>데이터 전송 암호화;</li>
          <li>데이터 접근 권한 통제;</li>
          <li>신원 인증 및 권한 관리;</li>
          <li>로그 및 보안 모니터링;</li>
          <li>데이터 백업;</li>
          <li>비정상 접근 탐지;</li>
          <li>보안 사고 대응 메커니즘.</li>
        </ul>
        <p>
          <strong>
            당사는 실제 비즈니스 상황에 따라, 개인정보가 무단으로 접근, 이용, 수정, 공개, 유실 또는 파괴되지 않도록
            합리적인 조치를 취합니다.
          </strong>
        </p>
        <p>다만 인터넷 환경은 절대적으로 안전하지 않습니다.</p>
        <p>
          개인정보 보안 사고가 발생하는 경우, 당사는 적용 법률 및 규정에 따라 상응하는 조치를 취하고, 법률에서 요구하는
          경우 지체 없이 피해를 입은 이용자와 규제 기관에 통지합니다.
        </p>
      </section>
      <section>
        <h2>7. 개인정보 보유 기간</h2>
        <p>
          당사는 본 개인정보 처리방침에 설명된 목적을 달성하는 데 필요한 기간 동안에만 이용자의 개인정보를 보유합니다.
        </p>
        <p>보유 기간은 주로 다음 요소에 따라 결정됩니다:</p>
        <ul>
          <li>관련 서비스 제공에 필요한 기간;</li>
          <li>이용자의 계정과 이력을 유지하는 데 필요한 기간;</li>
          <li>법률 및 규정이 요구하는 보유 기간;</li>
          <li>분쟁 해결 및 불만 처리에 필요한 기간;</li>
          <li>기타 법정 의무 이행에 필요한 기간.</li>
        </ul>
        <p>
          <strong>
            보유 기간이 경과하면, 당사는 적용 법률 및 규정에 따라 관련 정보를 삭제 또는 익명화하거나 기타 합법적인
            방식으로 처리합니다.
          </strong>
        </p>
        <p>
          이용자가 능동적으로 업로드한 이미지, 영상, PSD 파일, 프롬프트 및 기타 이용자 콘텐츠에 대해서는, 당사가
          구체적인 제품 기능, 이용자의 계정 상태 및 저장 규칙에 따라 보유 기간을 정합니다.
        </p>
      </section>
      <section>
        <h2>8. 개인정보에 대한 이용자의 권리</h2>
        <p>적용 법률 및 규정이 정한 범위 내에서, 이용자는 다음과 같은 권리를 가질 수 있습니다:</p>
        <h3>열람 및 조회</h3>
        <p>이용자는 당사가 보유한 이용자에 대한 개인정보를 조회하거나 열람할 수 있습니다.</p>
        <h3>정정</h3>
        <p>이용자의 개인정보에 오류나 부정확한 부분이 있음을 발견한 경우, 이용자는 당사에 정정을 요청할 수 있습니다.</p>
        <h3>삭제</h3>
        <p>법률 및 규정에 어긋나지 않는 범위에서, 이용자는 당사에 관련 개인정보의 삭제를 요청할 수 있습니다.</p>
        <h3>계정 탈퇴</h3>
        <p>이용자는 Xiangji가 제공하는 방법을 통해 계정 탈퇴를 신청할 수 있습니다.</p>
        <p>
          <strong>
            계정이 탈퇴된 후에는, 법률 및 규정이 보유를 요구하는 정보를 제외하고 서비스 데이터와 미사용 서비스 혜택의
            일부가 관련 규칙에 따라 소멸하거나 삭제될 수 있습니다.
          </strong>
        </p>
        <h3>동의 철회</h3>
        <p>법률이 허용하는 범위 내에서, 이용자는 당사에 사전에 부여한 동의의 일부를 철회할 수 있습니다.</p>
        <p>다만 동의를 철회하면 일부 기능이나 서비스의 정상적인 이용에 영향을 미칠 수 있습니다.</p>
        <h3>처리 제한 또는 거부</h3>
        <p>
          법률 및 규정에 어긋나지 않는 범위에서, 이용자는 당사에 개인정보 처리의 제한 또는 중지를 요청할 수 있습니다.
        </p>
        <h3>개인정보 사본 획득</h3>
        <p>적용 법률 및 규정이 허용하는 경우, 이용자는 자신의 개인정보 사본을 요청할 수 있습니다.</p>
        <p>
          상기 권리를 행사하고자 하는 경우, 본 개인정보 처리방침의 "문의하기" 절에 제공된 연락처를 통해 당사에 요청을
          제출할 수 있습니다.
        </p>
        <p>
          <strong>이용자의 계정과 개인정보의 보안을 보호하기 위해, 당사는 신원 확인이 필요할 수 있습니다.</strong>
        </p>
      </section>
      <section>
        <h2>9. 미성년자의 개인정보 보호</h2>
        <p>Xiangji의 서비스는 주로 성인과 비즈니스 이용자를 대상으로 합니다.</p>
        <p>
          <strong>
            18세 미만이라면, 부모님 또는 기타 법정 보호자와 함께 본 개인정보 처리방침을 읽고, 보호자의 동의를 받은 후
            관련 서비스를 이용해 주시기 바랍니다.
          </strong>
        </p>
        <p>
          미성년자가 보호자의 적법한 동의 없이 당사에 개인정보를 제공한 사실을 발견한 경우, 당사는 법률이 허용하는 범위
          내에서 합리적인 조치를 취해 처리합니다.
        </p>
      </section>
      <section>
        <h2>10. 제3자 서비스 및 링크</h2>
        <p>
          Xiangji의 서비스에는 제3자 웹사이트, 소프트웨어, 플러그인, 결제 서비스, AI 모델 또는 기타 제3자 서비스가
          포함될 수 있습니다.
        </p>
        <p>
          예를 들어, 이용자는 제3자 계정으로 로그인하거나 제3자 결제, AI 모델 및 기타 기술 서비스를 이용할 수 있습니다.
        </p>
        <p>
          <strong>
            제3자 서비스는 해당 제3자가 독자적으로 제공하며, 그 개인정보 처리 활동은 해당 제3자 자체의 개인정보
            처리방침에 따릅니다.
          </strong>
        </p>
        <p>관련 제3자 서비스를 이용하기 전에 해당 제3자의 개인정보 처리방침을 읽어 보시기를 권장합니다.</p>
      </section>
      <section>
        <h2>11. 본 개인정보 처리방침의 변경</h2>
        <p>
          법률 및 규정, 기술, 제품과 비즈니스의 발전에 따라, 당사는 본 개인정보 처리방침을 업데이트하거나 수정할 수
          있습니다.
        </p>
        <p>
          본 개인정보 처리방침에 중대한 변경이 발생하는 경우, 당사는 웹사이트 공지, 제품 페이지, 팝업, 사이트 내 알림
          또는 기타 합리적인 방식으로 이용자에게 알립니다.
        </p>
        <p>
          <strong>업데이트된 개인정보 처리방침은 공개일 또는 지정된 시행일부터 효력이 발생합니다.</strong>
        </p>
        <p>수정된 방침에 동의하지 않으시는 경우, 관련 서비스 이용을 중지할 수 있습니다.</p>
        <p>Xiangji의 서비스를 계속 이용하는 경우, 업데이트된 개인정보 처리방침을 읽고 이해한 것으로 간주됩니다.</p>
      </section>
      <section>
        <h2>12. 문의하기</h2>
        <p>
          본 개인정보 처리방침, 개인정보 처리 또는 기타 프라이버시 관련 사항에 대해 궁금한 점, 의견이나 불만이 있는
          경우, 다음 방법으로 당사에 연락할 수 있습니다:
        </p>
        <ul>
          <li>
            공식 웹사이트:
            <a href="https://www.xiangjifanyi.com/" rel="noreferrer" target="_blank">
              https://www.xiangjifanyi.com/
            </a>
          </li>
          <li>온라인 지원: Xiangji 제품 내 온라인 지원</li>
          <li>지원 이메일: 510807298@qq.com</li>
          <li>회사명: 苏州象寄科技服务有限公司 (Suzhou Xiangji Technology Service Co., Ltd.)</li>
          <li>
            회사 주소: <strong>上海市浦东新区纳贤路800号科海大楼 (상하이시 푸둥신구 나셴로 800호 커하이 빌딩)</strong>
          </li>
        </ul>
        <p>프라이버시 관련 요청을 접수한 후, 당사는 적용 법률 및 규정이 정한 기한 내에 처리합니다.</p>
      </section>
    </>
  );
};

export default KoContent;
